import { Flight as AirplaneIcon, DirectionsBus as BusIcon } from "@mui/icons-material";
import { useMemo } from "react";
import { groupTagsByCategory } from "../components/tagSelect/tags";

function useModeOfTransportation(ofPackage: { tags: { readonly category: string; readonly value: string }[] }) {
  return useMemo(() => {
    const group = groupTagsByCategory(ofPackage.tags);
    const first = group["Transport"]?.at(0);
    const second = group["Transport"]?.at(1);
    if (first && second) {
      return `${first}/${second}`;
    }
    return first;
  }, [ofPackage.tags]);
}

export function TransportationName(props: {
  forPackage: { tags: { readonly category: string; readonly value: string }[] };
}) {
  return useModeOfTransportation(props.forPackage);
}

export function TransportationIcon(props: {
  forPackage: { tags: { readonly category: string; readonly value: string }[] };
}) {
  return useModeOfTransportation(props.forPackage) === "Samolot" ? <AirplaneIcon /> : <BusIcon />;
}
